import { NavigateOptions, useNavigate } from 'react-router-dom';
import useSelectedEnv from './useSelectedEnv';

const useNavigateWithEnvParam = () => {
  const envid = useSelectedEnv();
  const navigateBase = useNavigate();
  const navigate = envid
    ? (to: string, options?: NavigateOptions) =>
        navigateBase(`/${envid}${to}`, options)
    : navigateBase;

  return navigate;
};

export default useNavigateWithEnvParam;
